/*global SunergoPlatform*/

/**
 * Setup in-field feedback messages for errors and more.
 * @param {object} form - the form item.
 */
const initFieldFeedback = function(form) {
	const validationFail = {
		message: form.element.dataset.i18nValidationFailMessage,
		one: form.element.dataset.i18nValidationFailCountOne,
		other: form.element.dataset.i18nValidationFailCountOther
	};

	form.fieldFeedback = {
		fields: {}
	};

	/**
	 * Clear all in-field feedback messages.
	 * @returns early when there is no feedback messages to clear.
	 */
	form.fieldFeedback.clear = function() {
		// Clear global feedback banner message.
		SunergoPlatform.feedbackBanner.clear();
		form.activeErrors = false;

		if (!this.fields || Object.keys(this.fields).length < 1) return;

		// Remove the error message and styling for each errored field.
		for (const fieldId in this.fields) {
			const item = this.fields[fieldId];
			item.field.dataset.status = '';
			item.feedback.innerHTML = '';
		}

		// Empty the error list.
		this.fields = {};
	};

	/**
	 * Set an in-field feedback message.
	 * @param {string} fieldName - Form field name
	 * @param {('info'|'success'|'warning'|'error')} status - Type of feedback message
	 * @param {string} message - Content of the feedback
	 * @returns early if there is an error.
	 */
	form.fieldFeedback.set = function(fieldName, status, message) {
		const fieldId = `${form.element.name}_${fieldName}`;
		const element = document.getElementById(fieldId);

		if (!element)
			return console.warn(
				'[Form / Feedback] Cannot find field to set feedback on:',
				fieldId
			);

		const container =
			element.closest('[data-field-id]') || element.closest('[data-fieldset-id]');

		if (!container)
			return console.error('[Form / Feedback] No parent field found:', fieldId, message);

		// Create the feedback item.
		const item = {
			field: container,
			feedback: container.querySelector(`[data-field-feedback="${fieldId}"]`)
		};

		if (!item.feedback)
			return console.error(
				'[Form / Feedback] No feedback container found:',
				fieldName,
				message
			);

		// Clear previous feedback messages and status.
		item.field.removeAttribute('data-status');
		item.feedback.innerHTML = '';

		// Check if there is a message.
		if (!message) {
			if (this.fields[fieldName]) delete this.fields[fieldName];
			return;
		}

		// If there is no status, set default 'info' status.
		status = status ? status : 'info';

		// Set field status.
		item.field.dataset.status = status;

		// Get the status icon from template.
		const statusIcon = SunergoPlatform.templates.clone(`field-status--${status}`);

		// If a status icon is found, insert it into the feedback message.
		if (statusIcon) item.feedback.appendChild(statusIcon);
		else console.warn(`[Form / Feedback] Status Icon "${status}" not found.`, item);

		// Insert the message content.
		item.feedback.innerHTML += message;

		// Add field to the errors list if not there already.
		if (!this.fields[fieldName]) this.fields[fieldName] = item;
	};

	/**
	 * Check if there are errors in the form.
	 * @returns true if there are in-field errors in form.
	 */
	form.fieldFeedback.checkErrors = function() {
		const errorCount = Object.keys(this.fields).length;
		if (errorCount < 1) {
			console.error('[Form / Feedback] Error check called, but no errors found in form.');
			SunergoPlatform.feedbackBanner.show({
				id: `${form.name}_form-error`,
				type: 'error',
				title: form.element.dataset.i18nRemoteErrorTitle,
				content: form.element.dataset.i18nRemoteErrorContent.replace('%s', 'Check called, no errors found'),
			});
			return;
		}

		// Create the global banner message.
		const changesNeeded = errorCount == 1 ? validationFail.one : validationFail.other;
		const errorBanner = validationFail.message.replace(
			'{{changes}}',
			changesNeeded.replace('{{num}}', errorCount)
		);

		// Add the global form message.
		SunergoPlatform.feedbackBanner.show({
			id: `${form.name}_form-error`,
			type: 'error',
			content: errorBanner
		});

		form.activeErrors = true;
		return true;
	};
};

export default initFieldFeedback;